import { fromJson, JsonResponse } from '@client/core/data/concerns/parses-from-json';
import { defineTransform } from '@client/core/data/concerns/parses-from-json/transform-map';
import { fromUnixTime } from '@client/core/utils/date';
import { User } from '@client/features/user/models/user';

interface PlanCharge {
  description: string;
  amount: number;
}

export class PlanChangeProjection {
  constructor(
    public readonly changeAt: Date,
    public readonly owner: User,
    public readonly charges: PlanCharge[],
    public readonly subtotal: number,
    public readonly amountDue: number,
    public readonly appliedCredit: number,
  ) {}
}

defineTransform(PlanChangeProjection, (json: JsonResponse) => {
  return {
    owner: fromJson(User, json.owner),
    changeAt: fromUnixTime(json.changeAt),
  };
});
